(() => {
  function initKeikoLinkGrid(root) {
    const cards = [
      ...root.querySelectorAll('.keiko-link-grid__card')
    ];

    const artworks = cards
      .map(card => {
        const width = parseFloat(card.dataset.widthCm);
        const height = parseFloat(card.dataset.heightCm);

        if (
          !Number.isFinite(width) ||
          !Number.isFinite(height) ||
          width <= 0 ||
          height <= 0
        ) {
          return null;
        }

        return {
          card,
          width,
          height,
          area: width * height
        };
      })
      .filter(Boolean);

    if (!artworks.length) return;

    const maxArea = Math.max(
      ...artworks.map(item => item.area)
    );

    artworks.forEach(({ card, width, height, area }) => {
      const physicalScale = Math.sqrt(area / maxArea);

      let scale;

      if (area === maxArea) {
        scale = 1;
      } else if (physicalScale >= 0.65) {
        scale = 0.90;
      } else if (physicalScale >= 0.35) {
        scale = 0.75;
      } else {
        scale = 0.59;
      }

      const isLandscape = width > height;

      card.classList.toggle(
        'keiko-link-grid__card--landscape',
        isLandscape
      );

      card.style.setProperty(
        '--klg-scale',
        `${scale * 100}%`
      );

      if (isLandscape) {
        const landscapeScale = Math.min(
          1,
          scale * (width / height) * 0.44
        );

        card.style.setProperty(
          '--klg-landscape-scale',
          `${landscapeScale * 100}%`
        );
      }
    });
  }

  document
    .querySelectorAll('.keiko-link-grid')
    .forEach(initKeikoLinkGrid);
})();